export function register(config) {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = '/service-worker.js'

      navigator.serviceWorker
        .register(swUrl)
        .then((reg) => {
          console.log('[PWA] Service worker registered:', reg.scope)

          reg.onupdatefound = () => {
            const installingWorker = reg.installing
            if (!installingWorker) return

            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
                console.log('[PWA] New content available — please refresh.')
                if (config && config.onUpdate) {
                  config.onUpdate(reg)
                }
              }
            }
          }
        })
        .catch((err) => {
          console.warn('[PWA] Service worker registration failed:', err)
        })

      let refreshing = false
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return
        refreshing = true
        window.location.reload()
      })
    })
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((reg) => reg.unregister())
      .catch(console.error)
  }
}
